import { render } from "./FoodMenuImportContainer.vue?vue&type=template&id=4f6fa128&ts=true"
import script from "./FoodMenuImportContainer.vue?vue&type=script&lang=ts"
export * from "./FoodMenuImportContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__